import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../Layout/PageHeader';
import '../../styles/notfound.css';
import img from '../../assets/404 error.svg';

const NotFound = () => {
  return (
    <main className="page notfound__page">
      <div className="page__inner notfound__content">
        <img src={img} alt="Page not found illustration" />
        <div>
          <PageHeader
            title="Page not found"
            description="The page you're looking for doesn't exist or has been moved."
          />
          <Link to="/" className="button">Back to home</Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
